import React from 'react';
import styled, { css } from 'styled-components';
import { primaryColor } from 'js/config/style';
import chroma from 'chroma-js';

const imageSize = '4.375rem';

const hoverStyle = css`
  .icon,
  .plus {
    fill: ${primaryColor.hex()};
  }
`;

const lightGrey = chroma('#ccc');
const darkGrey = chroma('#999');

export default styled(({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95.8 95.5">
    <title>Add image...</title>
    <path
      className="square"
      d="M18.5,9.9h59.1c5,0,9,4,9,9v59.1c0,5-4,9-9,9H18.5c-5,0-9-4-9-9V18.9C9.5,14,13.5,9.9,18.5,9.9z"
    />
    <path
      className="icon"
      d="M48,67.7H32.5c-0.3,0-0.6,0-1,0c-1.5-0.1-2-1-1.3-2.4c1.2-2.4,2.4-4.9,3.7-7.3l5-10
	c1-1.9,2-2,3.3-0.3c2.8,3.7,5.6,7.4,8.4,11c1.3,1.7,2.5,1.7,4,0.3c0.6-0.6,1.2-1.3,1.9-1.9c0.7-0.9,2-1,2.9-0.3
	c0.2,0.2,0.4,0.4,0.5,0.6c1.9,2.6,3.7,5.3,5.5,7.9c0.3,0.4,0.6,1.3,0.4,1.6c-0.4,0.4-1,0.7-1.6,0.7c-4.1,0.1-8.1,0-12.2,0L48,67.7z"
    />
    <path
      className="icon"
      d="M49.5,41.1c0-2.9,2.4-5.2,5.2-5.2c2.9,0,5.2,2.4,5.2,5.2s-2.4,5.2-5.2,5.2
	C51.8,46.3,49.5,44,49.5,41.1z"
    />
    <path
      className="icon"
      d="M61.9,68.7H34.2c-3.6,0-6.6-3-6.6-6.6V34.4c0-3.6,3-6.6,6.6-6.6h27.7c3.6,0,6.6,3,6.6,6.6v27.7
	C68.5,65.7,65.5,68.7,61.9,68.7z M34.2,30.4c-2.2,0-4,1.8-4,4v27.7c0,2.2,1.8,4,4,4h27.7c2.2,0,4-1.8,4-4V34.4c0-2.2-1.8-4-4-4
	L34.2,30.4z"
    />
    <polygon
      className="plus"
      points="73.8,96 73.8,82.7 60.9,82.7 60.9,73.1 73.8,73.1 73.8,59.8 83.4,59.8 83.4,73.1 96.3,73.1
	96.3,82.7 83.4,82.7 83.4,96 "
    />
    <path
      className="plus-outline"
      d="M80.9,62.3v13.3h13v4.6h-13v13.3h-4.5V80.2h-13v-4.6h13V62.3H80.9 M85.9,57.3H71.3v13.3h-13
	v14.6h13v13.3h14.6V85.2h13V70.6h-13V57.3z"
    />
  </svg>
))`
  &:hover {
    .icon,
    .plus {
      fill: ${darkGrey.hex()};
    }
    .square {
      stroke: ${darkGrey.darken(0.3).hex()};
    }
  }

  &:active {
    .plus {
      fill: #ccc;
    }
  }

  .square {
    fill: none;
    stroke: ${darkGrey.hex()};
    stroke-miterlimit: 10;
    stroke-dasharray: 5.99 5.99;
  }

  .plus-outline {
    fill: #ffffff;
  }

  .icon,
  .plus {
    fill: ${lightGrey.hex()};
  }

  height: ${({ size }) => size || imageSize};
  width: ${({ size }) => size || imageSize};
  float: left;
  clear: left;

  ${props => props.isHoveringFiles && hoverStyle};
`;
